import React from 'react';
import Button, { ButtonProps } from '@mui/material/Button';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as AddCircleIcon } from '../assets/icons/add-circle.svg';

interface AddItemButtonProps extends Pick<ButtonProps, 'onClick' | 'sx'> {
  label?: string;
  showIcon?: boolean;
}

const AddItemButton: React.FC<AddItemButtonProps> = ({ onClick, label = 'IDを追加', sx, showIcon = true }) => (
  <Button
    startIcon={showIcon ? <SvgIcon component={AddCircleIcon} inheritViewBox sx={{ fontSize: 18 }} /> : undefined}
    onClick={onClick}
    sx={[
      {
        bgcolor: '#cce3f9',
        color: '#0071e3',
        borderRadius: '20px',
        fontSize: '13px',
        fontWeight: 'bold',
        px: 1.5,
        py: 0.25,
        textTransform: 'none',
        '&:hover': { bgcolor: '#b3d6f7' },
      },
      ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
    ]}
  >
    {label}
  </Button>
);

export default AddItemButton;
